export default __webpack_public_path__ + "static/ryan-90a91cd995572153c11c74d25c57ee60.jpg";